/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   MinCities is a collection of mincity
 */

import { MCity } from '../../shared/bizos/city'

export const MinCitiesType = {
  jobId: 0,
  listingCount: 0,
  listingCounts: {},
  minCities: [],
  query: null,
  zoom: null,
}

export default {
  fromJS: (data) => {
    if (data) {
      const { jobId, listingCount, listingCounts, minCities, query } = data
      const minCitiesBizos = minCities.map((c) => MCity.fromJS(c))

      return {
        ...MinCitiesType,
        jobId,
        listingCount,
        listingCounts,
        minCities: minCitiesBizos,
        query,
      }
    }
    return MinCitiesType
  },
}
